//removes seconds and milliseconds from displaying in time input field
export const removeSeconds = (time: string) => {
	return time && time.length > 6 ? time.substring(0, time.length - 7) : time;
};
